'use client';
// libs
import { useContext } from 'react';
import { context } from './account.context';
import { Context } from './account.context.interface';

export function useAccount(): Context {
  return useContext(context);
}
